// state
const state = {
    active: false
};

// mutations
const mutations = {
    setActive(state, estado) {
        state.active = estado
    }
};

// actions
const actions = {
    setActive({commit}, payload) {
        commit('setActive', payload)
    }
};

// getters
const getters = {
    loadingActive: state => state.active,
};

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}


// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/loading.js